import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';
import CryptoJS from 'crypto-js';

function _standardizeName(name){
    return String(name).toLowerCase();
}

export function criptoLocalStorage(name, value) {
    const cipherValue = CryptoAES.encrypt(value, 'secret key 751');

    localStorage.setItem(_standardizeName(name), cipherValue.toString());

    return { criptoName: name,
        criptoValue: cipherValue.toString() };
}

export function criptObjectOnLocalStorage(name, value) {
    const chiperValue = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        'secret key 751'
    ).toString();

    localStorage.setItem(_standardizeName(name), chiperValue);

    return { criptoName: name,
        criptoValue: chiperValue };
}

export function decriptObjectOnLocalStorage(name) {
    try {
        const valueStorage = localStorage.getItem(_standardizeName(name));

        if (valueStorage) {
            const encryptedValue = CryptoJS.AES.decrypt(
                valueStorage,
                'secret key 751'
            );
            const decryptedValue = encryptedValue.toString(CryptoJS.enc.Utf8);

            return JSON.parse(decryptedValue);
        }
    } catch {
        localStorage.removeItem(_standardizeName(name));
    }
}

export function decriptoLocalStorage(name){
    try {
        const valueStorage = localStorage.getItem(_standardizeName(name));

        if(valueStorage){
            const _cipherValue = CryptoAES.decrypt(
                valueStorage,
                'secret key 751'
            );

            return { decriptoValue: _cipherValue.toString(CryptoENC) };
        }
    } catch (error) {
        localStorage.removeItem(_standardizeName(name));
    }
}
